module.exports = __webpack_public_path__ + "static/media/york-21.2ab6af59.jpg";